import { Base } from "ui/Scripts/source/framework/base";
import { ITaskEditTypeItem, TaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";

export interface ITaskEditUnitData {
    taskTypes: ITaskEditTypeItem[];
}

export class TaskEditUnitData implements ITaskEditUnitData {
    taskTypes: TaskEditTypeItem[];

    constructor();
    constructor(obj: ITaskEditUnitData);
    constructor(obj?: any) {
        this.taskTypes = Base.getTypedArray(obj ? obj.taskTypes : null, TaskEditTypeItem);
    }
}